var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickAverage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / circle-tick-filled@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Fives---01---Account",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.0.6---Continue-with-email---no-account---sign-up---set-password---good",
    transform: "translate(-20.000000, -332.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-circle-tick-filled",
    transform: "translate(20.000000, 332.697981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99549526,0 C15.5156257,0.0125412938 19.9874542,4.48276382 20,10.0009117 C19.9994283,12.9947588 18.6571552,15.8308877 16.3419713,17.73007 C14.0267874,19.6292524 10.982228,20.3917122 8.04478795,19.8079632 C3.00239637,18.8007968 -0.455097776,14.1365869 0.0486805086,9.02109794 C0.552458793,3.90560898 4.85343324,0.00491185605 9.99549526,0 Z M9.41703239,14.7536003 C9.09041481,14.4287111 9.09041481,13.9046748 9.41703239,13.5797856 C9.57404547,13.4259532 9.78596676,13.339081 10.0072139,13.3378543 C10.3281229,13.3048817 10.640021,13.4552544 10.8109069,13.7253317 C10.9817927,13.9954089 10.9817927,14.337977 10.8109069,14.6080542 C10.640021,14.8781315 10.3281229,15.0285042 10.0072139,14.9955316 C9.78596676,14.9943049 9.57404547,14.9074327 9.41703239,14.7536003 Z M9.23201821,4.96117229 C9.22809837,4.75007594 9.31527699,4.54728343 9.47181423,4.40336538 C9.6123616,4.25150971 9.81151987,4.16552278 10.0199194,4.16669294 C10.23341,4.16494334 10.4380839,4.25063384 10.5851529,4.40336538 C10.7416901,4.54728343 10.8288687,4.75007594 10.8249489,4.96117229 L10.8249489,11.1984676 C10.8261621,11.404129 10.7390303,11.6006706 10.5851529,11.7393713 C10.4380839,11.8921029 10.23341,11.9777933 10.0199194,11.9760437 C9.59222258,11.9587677 9.24949679,11.620545 9.23201821,11.1984676 L9.23201821,4.96117229 Z",
    id: "Combined-Shape",
    fill: "#FECB1C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.055570, 9.583346) rotate(-180.000000) translate(-10.055570, -9.583346) translate(9.172069, 4.166667)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickAverage);
export default __webpack_public_path__ + "static/media/tick-average.7feda40f73461051f85251007785a1cd.svg";
export { ForwardRef as ReactComponent };